import script from "./SearchAttributeContents.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchAttributeContents.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__